<template>
    <nav aria-label="Page navigation example">
        <ul class="pagination justify-content-end">
            <li
                v-for="(link, index) in links"
                class="page-item"
                :class="{active: link.active, disabled: !link.url}"
            >
                <a class="page-link" :href="link.url ?? '#'">
                    <svg v-if="index === 0 " xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
                    </svg>

                    <svg v-else-if="index === links.length-1" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                        <path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
                    </svg>
                    <span v-else>
                        {{ link.label }}
                    </span>
                </a>
            </li>
        </ul>
    </nav>
</template>

<script>
export default {
    name: "Pagination",
    props: {
        links: {
            type: Object,
            required: true
        }
    },
}
</script>

<style scoped>
    .size-6 {
        height: 1rem;
        width: 1rem;
    }
</style>
